module.exports = __webpack_public_path__ + "static/media/logo_big.d57ca735.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo_big.svg
// module id = 175
// module chunks = 0